import { getStore as getRootStore } from 'stores/common/selectors';
import { modalInitialState, ModalStore } from './store';
import { selectors as pullRequestsSelectors } from 'stores/pullRequests';
import { PullRequest } from 'stores/pullRequests/models';
import { selectors as projectsSelectors } from 'reducers/projects';
import { Project } from 'models/Project';
import { createSelector } from 'reselect';

function getStore(state: any): ModalStore {
  const rootStore = getRootStore(state);
  return rootStore?.reviews?.modals ?? modalInitialState;
}

function pullRequest(state: any): PullRequest | undefined {
  const store = getStore(state);
  return pullRequestsSelectors.entryData(state, store.pullRequestUUID);
}

const pullRequestProject = createSelector(
  [pullRequest, projectsSelectors.projects],
  (pullRequest: PullRequest | undefined, projects: Project[] | undefined) => {
    if (pullRequest === undefined || !projects) {
      return undefined;
    }
    return (
      projects.find(
        (project: Project) => project.name === pullRequest.repository
      ) || undefined
    );
  }
);

export const selectors = {
  getStore,
  pullRequest,
  pullRequestProject,
};
